module.exports = __webpack_public_path__ + "0d16b0e8d8769ea32bc60c91491a6759.svg";